// src/js/components/Evaluation/Results.js
import React, { Component } from "react";
import { connect } from "react-redux";
// import renderHTML from "react-render-html";
import BenchmarkBarElement from "./BenchmarkBarElement";
import BenchmarkBarArrow from "./BenchmarkBarArrow";
import BenchmarkLegend from "./BenchmarkLegend";

import './SubmoduleResults.css';

const mapStateToProps = state => {
    return {
        benchmark: state.data.benchmark.modules
    };
};

function mapDispatchToProps(dispatch) {
    return {};
}

class ConnectedSubmoduleResults extends Component {
    constructor(props) {
        super(props);

        this.state = {
            width: 0,
            textwidth: 75
        };

        this.displayUnsure = this.displayUnsure.bind(this);
        this.containerWidth = this.containerWidth.bind(this);
    }

    componentDidMount() {
        let width = document.getElementById('evBenchmarkBarContainer').offsetWidth;
        let textwidth = document.getElementById('evBenchmarkBarArrow').offsetWidth;

        this.setState({
            width: width, textwidth: textwidth
        });
    }

    displayUnsure(unsure) {
        if(unsure) {
            return( <div>Unsure response given</div>)
        }
    }

    containerWidth(per) {
        let calc = (this.state.width * (per / 100)) - (this.state.textwidth/2);
        return calc;
    }

    render() {
        // determine benchmark data to use in this page
        let submodulearrayindex = parseInt(this.props.submoduleindex,10) - 1;
        let thisbenchmark = this.props.benchmark[this.props.moduleindex].submodules[submodulearrayindex];

        let displaypercentage = thisbenchmark.answers[3].percentage + (thisbenchmark.answers[2].percentage / 2);
        let displayClass = "early";
        // let response = 2;
        if (this.props.submodule.average === 100) {
            displayClass = "mature";
            // response = 0;
            displaypercentage = thisbenchmark.answers[3].percentage + thisbenchmark.answers[2].percentage + thisbenchmark.answers[1].percentage + (thisbenchmark.answers[0].percentage / 2);
        } else if (this.props.submodule.average > 75 && this.props.submodule.average < 100) {
            displayClass = "maturing";
            // response = 1;
            displaypercentage = thisbenchmark.answers[3].percentage + thisbenchmark.answers[2].percentage + thisbenchmark.answers[1].percentage;
        } else if (this.props.submodule.average > 50 && this.props.submodule.average <= 75 ) {
            displayClass = "developing";
            // response = 1;
            displaypercentage = thisbenchmark.answers[3].percentage + thisbenchmark.answers[2].percentage + (thisbenchmark.answers[1].percentage / 2);
        } else if (this.props.submodule.average === 0) {
            // response = 3;
            displaypercentage = thisbenchmark.answers[3].percentage / 2;
        }

        let displayClassUnsure = "";
        // add a blue tick if an unsure answer was given.
        if(this.props.submodule.unsure) {
            displayClassUnsure =  "unsure";
        }

        let questionText = "this question";
        if (thisbenchmark.questions.length > 1) {
            questionText = "these questions";
        }

        return(
            <div className="evResultSubmodule">
                <h3>{this.props.submodule.title}</h3>
                <ul className="evResultSubmoduleQuestionUL">{thisbenchmark.questions.map((question,index) => { return( <li key={index}>{question}</li> )} )}</ul>
                <div>
                    <div className="evIndividualResultTitle">
                        <div className="evIndividualResultTitleText">Your Response</div>
                        <div className={`evIndividualResult ${displayClass} ${displayClassUnsure}`}>{displayClass}</div>
                        {this.displayUnsure(this.props.submodule.unsure)}
                    </div>
                    <div className="evBenchmarkResult">
                        <div className="evBenchmarkResultTitle">2020 Benchmark results for {questionText}.</div>
                        <div className="evBenchmarkBarContainer" id="evBenchmarkBarContainer">
                            <BenchmarkBarElement bartype="unsure" width={thisbenchmark.answers[3].percentage} />
                            <BenchmarkBarElement bartype="early" width={thisbenchmark.answers[2].percentage} />
                            <BenchmarkBarElement bartype="developing" width={thisbenchmark.answers[1].percentage} />
                            <BenchmarkBarElement bartype="mature" width={thisbenchmark.answers[0].percentage} />
                            <BenchmarkBarArrow percentage={displaypercentage} elementwidth={this.state.width} positionwidth={this.containerWidth(displaypercentage)} textwidth={this.state.textwidth} />
                        </div>
                        <BenchmarkLegend questionText={questionText} />
                    </div>
                    <div className="evModuleClear">
                    </div>
                </div>
            </div>
        )
    }
}
const SubmoduleResults = connect(mapStateToProps,mapDispatchToProps)(ConnectedSubmoduleResults);

export default SubmoduleResults;